import { gql } from "@apollo/client";

export const ON_COMPANY_DATA_IMPORT_JOB_TOTAL_COUNT_SUBSCRIPTION = gql`
  subscription OnCompanyDataImportJobTotalCount($companyId: Int!) {
    company_data_import_job_aggregate(
      where: { company_id: { _eq: $companyId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;
